import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Edit, Trash2, Plus } from 'lucide-react';
import './BanktypeList.css';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;


const BanktypeList = () => {
  const [banktype, setBanktype] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBanktype = async () => {
      try {
        const response = await axios.get(`${url}/api/bank`);
        setBanktype(response.data.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch Bank Type');
      } finally {
        setLoading(false);
      }
    };

    fetchBanktype();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${url}/api/bank/${id}`);
      setBanktype(banktype.filter(banktype => banktype._id !== id));
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to delete Bank Type');
    }
  };

  if (loading) return <div className="loading">Loading Bank Type...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="countries-container">
      <div className="header">
        <h2>Bank Management System</h2>
        <button 
          onClick={() => navigate('/AddBanktype')}
          className="add-button"
        >
          <Plus size={16} /> Add Bank Type
        </button>
      </div>

      <table className="countries-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Wallet Number</th>
            <th>Deposit</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {banktype.map(banktype => (
            <tr key={banktype._id}>
              <td>{banktype.name}</td>
              <td>{banktype.number}</td>
              <td>${banktype.debit.toFixed(2)}</td>
              {/* <td>{banktype.debit}</td> */}
              <td className="actions">
                <button 
                  onClick={() => navigate(`/bank/edit/${banktype._id}`)}
                  className="edit-btn"
                >
                  <Edit size={14} />
                </button>
                {/* <button 
                  onClick={() => handleDelete(banktype._id)}
                  className="delete-btn"
                >
                  <Trash2 size={14} />
                </button> */}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BanktypeList;